
export default (() => {
    const expiryNotification = document.querySelector('.expiry-notification-strip');
    const accountContainer = document.querySelector('.account');
    const expiryNotificationCloseButton = document.querySelector('.expiry-notification-strip__close');

    if (expiryNotification) {
        accountContainer.classList.add('account--is-expired');

        expiryNotificationCloseButton.addEventListener('click', (event) => {
            event.preventDefault();
            closeNotificationStrip();
        });
    }

    const closeNotificationStrip = () => {
        accountContainer.classList.remove('account--is-expired');
        expiryNotification.classList.add('expiry-notification-strip--closed');
    };
})();